import { useState } from 'react';

import Fade from 'react-reveal/Fade';
import Pulse from 'react-reveal/Pulse';
import Slide from 'react-reveal/Slide';

import * as Styled from './styled';

export const Home: React.FC= () => {
    const [isTrigger, trigger] = useState(0);
    return (
        <>
            <Styled.LandingPage>
                <Pulse spy={isTrigger}> 
                    <Styled.Img src={require('Assets/logo.png')} alt="labelilogo" onClick={() => trigger(isTrigger+1)}/>
                </Pulse>
                <Styled.ButtonWrapper>
                    <Styled.Button color={'#5769E9'} onClick={()=> {window.open('https://discord.gg/RH3Ck5MG7S','_blank');}} >
                    Discord
                    </Styled.Button>
                    <Styled.Button color={'#C33491'} onClick={()=> {window.open('https://www.instagram.com/asso_labeli/','_blank');}} >
                        Instagram
                    </Styled.Button>
                </Styled.ButtonWrapper>
                <Styled.scrollAnim/>
            </Styled.LandingPage>
            <Styled.SpacerOne/>

            <Styled.EventPage>
                
                <Styled.EventRow>
                    <Slide left>
                        <Styled.RowTitle>Des événements annuels...</Styled.RowTitle>
                    </Slide>
                    <Slide right>
                        <Styled.EventCard rotate={'2deg'} left={true}>
                            <h1>Nuit de L'info 🧑🏻‍💻</h1>
                            <img src={require('Assets/ndilogo.png')} alt="" />
                            <p>Le plus fun serious-game regroupant des milliers d’étudiants pour 
                        développer une application informatique en une nuit.</p>
                        </Styled.EventCard>
                    </Slide>
                </Styled.EventRow>
                <Styled.EventRow>
                    <Slide left>
                        <Styled.EventCard rotate={'-2deg'} >
                            <h1>Stand de Crêpes 🧑🏻‍🍳</h1>
                            <img src={require('Assets/crepes.png')} alt="" />
                            <p>Qui a dit que des informaticiens ne savaient pas cuisiner ?!</p>
                            <p>En tout cas, on l'a fait !</p>
                        </Styled.EventCard>
                    </Slide>
                    
                    <Slide right>
                        <Styled.RowTitle>mais aussi des choses inatendues</Styled.RowTitle>
                    </Slide>
                    
                </Styled.EventRow>
            </Styled.EventPage>

            <Styled.SpacerTwo/>

            <Styled.EndingPage>
                <Fade bottom>
                    <Styled.Title>Comment nous rejoindre ?</Styled.Title>
                </Fade>
                <Styled.Spacer/>
                <Styled.EventRow>
                    <Slide left>
                        <Styled.Solution>
                            <Styled.Subtitle>Solution n°1 :</Styled.Subtitle>
                            <p>Tu peux venir nous rencontrer au local et payer la cotisation annuelle en espece ou CB (oui on a ça :p )</p>
                            <p>📍Campus Talence , Bat A21, local 31 </p>
                        </Styled.Solution>
                    </Slide>
                    <Slide right>
                        <Styled.Solution>
                            <Styled.Subtitle>Solution n°2 :</Styled.Subtitle>
                            <p>Tu peux régler ta cotisation annuelle via :</p>
                            <a
                                href='https://www.helloasso.com/associations/label-i/adhesions/adhesion-2022-2023' target='_blank'
                            >
                                <img src={require('Assets/helloasso.png')} alt="" /></a>
                            <p>Mais un jour il faudra venir nous voir hein ! </p>
                        </Styled.Solution>
                    </Slide>
                </Styled.EventRow>
               
            </Styled.EndingPage>
        </>
    );
};
